<template>
    <CheckoutPart></CheckoutPart>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const CheckoutPart = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/EngineeringWorkbench/CheckoutPart.vue"
    )
);

export default {
    name: "Project_HelpCheckoutPart", //The name you are in should not equal the name of the component you are importing.
    components: { CheckoutPart, AuthLayout },
};
</script>
